import React from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './BackButton.module.css';

interface BackButtonProps {
  className?: string;
}

const BackButton: React.FC<BackButtonProps> = ({ className }) => {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <button 
      onClick={handleBack}
      className={`${styles.backButton} ${className || ''}`}
      aria-label="Go back to previous page"
    >
      ← Back
    </button>
  );
};

export default BackButton;